import { LINEAR_LOGO } from "../data/site";

export function SiteFooter() {
  return (
    <footer
      data-testid="footer"
      className="bg-[#2C3639] px-6 py-24 sm:px-8 sm:py-28"
    >
      <div className="mx-auto flex max-w-[760px] flex-col items-center gap-6 text-center">
        <img
          src={LINEAR_LOGO}
          alt="Raintree Holdings"
          data-testid="footer-logo"
          className="h-[101px] w-auto sm:h-[115px]"
        />
        <p
          data-testid="footer-text"
          className="text-sm tracking-tight text-[#A27B5B]"
        >
          Raintree Holdings Ltd. · Established 2006 · Victoria, British
          Columbia · © 2026
        </p>
      </div>
    </footer>
  );
}
